export const ToggleContents = () => {
  const toggleButton = $(".js-toggle-button");

  toggleButton.on("click", function () {
    const toggleContents = $(this).next();
    $(this).toggleClass("is--open");
    toggleContents.slideToggle();
  });
};
